import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'shabic-icon-alert',
  templateUrl: './icon-alert.component.html',
  styleUrls: ['./icon-alert.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconAlertComponent {
  @Input() size?: 'lg';
}
